import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter, skip } from 'rxjs/operators';
import { environment } from '../environments/environment';

declare var ttq: any;
declare var gtag: any;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {

  title = 'ALDawalUI';

  constructor(
    private translate: TranslateService,
    private router: Router
  ) { }

  ngOnInit(): void {

    this.router.events
      .pipe(
        filter(
          (event): event is NavigationEnd =>
            event instanceof NavigationEnd
        ),
        skip(1)
      )
      .subscribe((event: NavigationEnd) => {

        // TikTok page tracking
        if (typeof ttq !== 'undefined') {
          ttq.page();
        }

        // Google Analytics page tracking
        if (typeof gtag !== 'undefined') {
          gtag('event', 'page_view', {
            send_to: environment.googleAnalyticsId,
            page_title: document.title,
            page_location: window.location.href,
            page_path: event.urlAfterRedirects
          });
        }

      });

  }

  onActive(): void {
    window.scroll(0, 0);
  }

}